module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-wrapper"
  }, [_c('docs-sidebar-container'), _vm._v(" "), _c('toolbar-view', {
    attrs: {
      "highlight-save": !_vm.docSaved
    },
    on: {
      "export": function($event) {
        _vm.onExport('doc')
      },
      "save": _vm.onSave,
      "open": _vm.onLoad,
      "undo": function($event) {
        _vm.onEditorAction('editorUndo')
      },
      "redo": function($event) {
        _vm.onEditorAction('editorRedo')
      },
      "copy": function($event) {
        _vm.onEditorAction('editorCopy')
      },
      "cut": function($event) {
        _vm.onEditorAction('editorCut')
      },
      "paste": function($event) {
        _vm.onEditorAction('editorPaste')
      },
      "header": function($event) {
        _vm.onEditorAction('editorHeader')
      },
      "list": function($event) {
        _vm.onEditorAction('editorList')
      },
      "add-source": _vm.openAddSourceDialog
    }
  }), _vm._v(" "), _c('article-view', {
    ref: "editor",
    attrs: {
      "links": _vm.linksLabels,
      "content-html": _vm.contentHtml
    },
    on: {
      "input": _vm.onChangeContent,
      "add-source": _vm.openAddSourceDialog,
      "edit-link": _vm.onEditLink,
      "set-doc-name": _vm.onSetDocName,
      "export": _vm.onExport
    }
  }, [_c('lit-list-container', {
    attrs: {
      "slot": "lit-list",
      "sources": _vm.sources
    },
    slot: "lit-list"
  })], 1), _vm._v(" "), _c('export-container', {
    ref: "exportContainer"
  }), _vm._v(" "), _c('source-dialog-container', {
    ref: "sourceDialog",
    on: {
      "add-link": _vm.onAddLink
    }
  }), _vm._v(" "), _c('base-timer', {
    attrs: {
      "timeout": 5000
    },
    on: {
      "timer": _vm.onSaveTimer
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc0b0ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleContainer.vue
// module id = 997
// module chunks = 1